export const getSafeString = (string: string) => {
    return string ?? '';
};
